export const API_BASE_URL = 'https://mro3wv8j0i.execute-api.us-east-2.amazonaws.com/prod/api/v1';
export const API_BASE_SECURE_URL = 'https://kbqc84vx22.execute-api.us-east-2.amazonaws.com/prod/api/v1';
export const API_FILE_UPLOAD_URL = 'https://xptmfvphme.execute-api.us-east-2.amazonaws.com/prod/api/v1/wapichana-file-upload';
export const MEDIA_URL = 'https://wapichana-bucket-wapichana8b6fb576-1asnzx4uxnhi5.s3.us-east-2.amazonaws.com'

export const AWS_REGION = 'us-east-2';
export const USER_POOL_ID = 'us-east-2_VOKDotbjh';
export const APP_CLIENT_ID = '1qknb6e2d94jkil2lr9jqmh9oq';